import { camelCase } from '@edicom/common/case/camelCase';
import FbTemplateCellEditorClass from '../cells/fb-template-cell-editor.class';

export default function templateCellService({ FbCellEditor, TYPES }) {
  return function generate(viewField, engineApi, engineGridApi) {
    const column = engineApi.cell.setCommonAttributes(viewField, engineApi, engineGridApi);
    const type = camelCase(viewField.type);

    /**
     * renderer
     * Dejamos que el ec-grid-edit gestione el renderer en función del tipo.
     */

    column.renderer = type;

    /**
     * editor
     * Creamos un `FbTemplateCellEditor` para
     * - pasar las opciones en el constructor (en función del tipo. de momento solo `select`)
     * - sobreescribir el metodo `render` del EcCellEditor.
     *
     * > Si no fuera para las `options`, se podría pasar directamente una function al column.editor.
     */
    const template = generateTemplate(type);
    const render = function() {
      // no cambiar a ()=> es importante que este function para mantener el bind(this)
      const typeAutoFocus = type !== 'select' && this.isKeyEditPress ? 'select' : 'force'; // para los tipo select hay que poner force por que si no pierde la referencia del tab
      return template
        .addAttribute('ec-autofocus', typeAutoFocus) // forzamos el autofocus
        .toString();
    };
    const options = getConstructorTypeOptions(type);
    column.editor = FbTemplateCellEditorClass(FbCellEditor, options, { render });

    return column;

    /**
     * Genera el template y devuelve el metodo render
     * @returns {function}
     */
    function generateTemplate(type) {
      // primero buscamos la función `generate` del tipo `type`.
      // se trata de la función estandár para generar un campo de tipo cabecera.
      const generatorService = TYPES[type]();

      // ejecutamos la función para generar el template fijo,
      // que sobreescribimos para que se adapte a la celda del grid.
      return (
        generatorService(viewField, engineApi)
          ///////////////////
          ///////////////////
          ///////////////////
          // .addAttribute('ng-model', 'value') // @odeniel 18/10/2021 quito ng-model="value" para simplificar, que campos de linea sean con su model como los de cabecera
          .addAttribute('ng-model', 'value') // @odeniel 25/10/2021 lo vuelvo a poner para EXTRADATA
          // los EXTRADATA vienen con un modelo complejo, no es un simple "field"
          // el value se encarcaga desde el EcCellEditor de hacer bien el binding

          ///////////////////
          ///////////////////
          ///////////////////
          .addAttribute('ec-flex', '8') // forzamos que el input se extiende al 100% de la celda
          .addAttribute('inline', '') // quitamos label, errores y padding
      );
    }
  };
}

/**
 * Devuelve las opciones de columna, del constructor, en función del tipo
 * @param {string} type el tipo de campo ej. 'string', 'select',...
 * @returns {Object}
 */
function getConstructorTypeOptions(type) {
  const options = {
    select: {
      stopPropagation: ['home', 'end', 'arrowup', 'arrowdown', 'enter'],
    },
  };

  // aprovechamos para sobreescribir el nombre de la celda
  return Object.assign({ ecCellName: `FbTemplateCellEditor:${type}` }, options[type] ?? {});
}
